import {Config} from "../models/Config";

const config: Config = {
    // REACT_APP_API_URL lets a gitignored .env.local point local dev at another backend
    apiUrl: process.env.REACT_APP_API_URL || "http://127.0.0.1:5000",
    // no cdn in front of a local backend - content reads go straight to it
    contentUrl: process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"
};
export default config;
